import React, {useEffect} from "react";
import { IonRouterOutlet } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { Route } from "react-router-dom";
import PickupComplete from "Components/LocalHome/PickupComplete/PickupComplete";
import LocalPickupView from "Components/LocalHome/LocalPickupView/LocalPickupView";
import LocalSchedule from "Components/LocalHome/LocalSchedule/LocalSchedule";
import LocalRate from "Components/LocalHome/LocalRate/LocalRate";
import LocalHome from "Components/LocalHome/LocalHome";
import "./WebMode.css"
import AuthCallback from "Components/AuthCallback/AuthCallback";
import LogRocket from 'logrocket';


const WebMode = () => {

  useEffect(()=>{
    const logrocketId = process.env.REACT_APP_LOGROCKET
    if(logrocketId) LogRocket.init(logrocketId)
  },[])

  return (
    <IonReactRouter>
      <IonRouterOutlet>
        <Route path="/local-pickup-complete" component={PickupComplete} />
        <Route path="/w/pickup-view" component={LocalPickupView} />
        <Route path="/w/schedule-pickup" component={LocalSchedule} />
        <Route path="/local-rate" component={LocalRate} />
        <Route path="/home" component={LocalHome} />
        <Route path="/callback" component={AuthCallback} />
        <Route path="/" exact component={LocalHome} />
      </IonRouterOutlet>
    </IonReactRouter>
  );
};

export default WebMode;
